import { render } from "./modal.vue?vue&type=template&id=4e7bb8bd"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/forum/modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e7bb8bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e7bb8bd', __exports__)) {
    console.log('reload')
    api.reload('4e7bb8bd', __exports__)
  }
  
  module.hot.accept("./modal.vue?vue&type=template&id=4e7bb8bd", () => {
    console.log('re-render')
    api.rerender('4e7bb8bd', render)
  })

}


export default __exports__